import React from "react";
import "./EbookList.css";
import gd from "../../images/green-dark-tick.svg";
import bc from "../../images/book-cover.svg";
import dd from "../../images/download-white.svg";
import lb from "../../images/lock-black.svg"
import pl from "../../images/play-btn.svg"
import pt from "../../images/purple-tick.svg"



function EbookList() {
  return (
    <div className="ebooklist-cont">
      <div className="container">
        <div className="row">
          <div className="ebooklist-title">
            <h4>Book Ownership States</h4>
            <p>
              Visual examples of how the same book can appear on the user’s
              ownership status
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="ebooklist-box">
              <div
                className="ebooklist-iconDiv"
                style={{ "--text-color-h6": "#39B46E" ,"--border-box-color":"#39B46E", "--box-bg-color":"#F0F6F4"}}
              >
                <img src={gd} alt="" />
                <h6>User Owns the Book</h6>
              </div>

              <div className="ebooklist-imgDiv">
                <img src={bc} alt="" />
              </div>

              <div className="ebooklist-contentall">
                <h6>The Adapter</h6>
                <p>
                  Your blueprint for thriving in a world that never stops
                  shifting. Learn to stay steady, flexible, and focused-no
                  matter what life (or people) throw your way.
                </p>

                <h5>$1.99</h5>

                <div className="adapter-single-acout-dec">
                  <img alt="" src={gd} />
                  <div>
                    <h6>Instant download available</h6>
                    <p>If owned or included in subscription</p>
                  </div>
                </div>

                <div className="ebooklist-allbtn">
                  <button className="ebook-download">
                    <img src={dd} alt="" /> <span>Download</span>
                  </button>
                  <button className="ebook-buy-now">Buy Now</button>
                  <button className="ebook-download">Take the Quiz</button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="ebooklist-box">
              <div
                className="ebooklist-iconDiv"
                style={{ "--text-color-h6": "#88619A" ,"--border-box-color":"#88619A", "--box-bg-color":"#E4DCEE"}}
              >
                <img src={pl} alt="" />
                <h6>User Owns the Book</h6>
              </div>

              <div className="ebooklist-imgDiv">
                <img src={bc} alt="" />
              </div>

              <div className="ebooklist-contentall">
                <h6>The Adapter</h6>
                <p>
                  Your blueprint for thriving in a world that never stops
                  shifting. Learn to stay steady, flexible, and focused-no
                  matter what life (or people) throw your way.
                </p>

                <h5>$1.99</h5>

                <div className="adapter-single-acout-dec">
                  <img alt="" src={pt} />
                  <div>
                    <h6>Instant download available</h6>
                    <p>If owned or included in subscription</p>
                  </div>
                </div>

                <div className="ebooklist-allbtn">
                  <button className="ebook-download">
                    <img src={dd} alt="" /> <span>Download</span>
                  </button>
                  <button className="ebook-buy-now">Buy Now</button>
                  <button className="ebook-download">Take the Quiz</button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="ebooklist-box">
              <div
                className="ebooklist-iconDiv"
                style={{ "--text-color-h6": "#000", "--box-bg-color":"#FBFBFB","--border-box-color":"#E0E0E0" }}
              >
                <img src={lb} alt="" />
                <h6>User Owns the Book</h6>
              </div>

              <div className="ebooklist-imgDiv">
                <img src={bc} alt="" />
              </div>

              <div className="ebooklist-contentall">
                <h6>The Adapter</h6>
                <p>
                  Your blueprint for thriving in a world that never stops
                  shifting. Learn to stay steady, flexible, and focused-no
                  matter what life (or people) throw your way.
                </p>

                <h5>$1.99</h5>

                <div className="adapter-single-acout-dec">
                  <img alt="" src={gd} />
                  <div>
                    <h6>Instant download available</h6>
                    <p>If owned or included in subscription</p>
                  </div>
                </div>

                <div className="ebooklist-allbtn">
                  <button className="ebook-download">
                    <img src={dd} alt="" /> <span>Download</span>
                  </button>
                  <button className="ebook-buy-now">Buy Now</button>
                  <button className="ebook-download">Take the Quiz</button>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}

export default EbookList;
